export const GoogleAnalyticsID = {
    dk: 'UA-3237872-1',
    se: 'UA-19710286-1',
    no: 'UA-19709742-1',
    da: 'UA-699100-1'
}